<template>

    <div>

        <b-card>

            <form @submit.prevent="submit()" @keydown="form.clearError($event.target.name)">

                <b-row>

                    <b-col xl="12">

                        <b-form-group label="Participants">

                            <user-search-dropdown
                                placeholder="Add Participants"
                                icon="fa-plus"
                                @selectUser=" addUser "
                                :carrier-based=" !isCarrierManager "
                                :role=" role "
                                :onlyOfficeUsers=" isCarrierManager "
                                :disabled=" isCarrierManager "
                            />

                            <div class="mt-2 user-pills">

                                <b-badge pill
                                    :href="`/${controller}/${mapRoleToController( user.role_type )}/${user.id}`"
                                    target="_blank"
                                    v-for="user in participants" 
                                    :key="user.id" 
                                    variant="light">
                                    {{ user.name }} ({{ user.role_type }})

                                    <a href="#" class="delete-btn" @click.stop="removeParticipant(user.id)" v-if="!isCarrierManager "><i class="fa fa-times"></i></a>
                                </b-badge>
                            </div>

                            <input-help :form="form" field="participants" text=""></input-help>
                        </b-form-group>

                        <b-form-group label="Subject" label-for="subject">
                            <b-form-select
                                id="subject"
                                name="subject"
                                v-model="form.subject"
                                :disabled=" isCarrierManager "
                            >
                                <option value="">-- Choose Subject --</option>
                                <option v-for="item in subjects" :value="item.subject" :key="item.id">{{ item.subject }}</option>
                            </b-form-select>
                            <input-help :form="form" field="subject" text=""></input-help>
                        </b-form-group>

                        <b-form-group label="Description" label-for="description">
                            <b-textarea id="description" :rows="10" v-model="form.description" :disabled=" isCarrierManager " />
                            <input-help :form="form" field="description" text="" />
                        </b-form-group>

                        <b-form-group label="Actions / Next Steps" label-for="actions">
                            <b-textarea id="actions" :rows="10" v-model="form.actions" :disabled=" isCarrierManager " />
                            <input-help :form="form" field="actions" text="" />
                        </b-form-group>

                        <b-form-group label="illumifin Admin" label-for="office_user_id">
                            <b-form-select
                                id="office_user_id"
                                name="office_user_id"
                                v-model="form.office_user_id"
                                :disabled=" isCarrierManager "
                            >
                                <option v-for="admin in admins" :key="admin.id" :value="admin.id">{{ admin.nameLastFirst }}</option>
                            </b-form-select>
                            <input-help :form="form" field="office_user_id" text=""></input-help>
                        </b-form-group>

                    </b-col>
                </b-row>
                <b-row v-if=" !isCarrierManager ">
                    <b-col lg="12">
                        <b-button v-if=" call.id " variant="success" type="submit">Save Changes</b-button>
                        <b-button v-else variant="success" type="submit">Submit</b-button>
                    </b-col>
                </b-row>
            </form>
        </b-card>
    </div>
</template>

<script>

    import HandlesScopedUser from '../../../mixins/HandlesScopedUser';
    import UsesRole from '../../../mixins/UsesRole';

    export default {

        mixins: [ HandlesScopedUser, UsesRole ],
        props: {

            call: {
                type: Object,
                default() { return {} },
            },
            subjects: {
                type: Array,
                default() { return [] },
            },
            authUser: {
                type: Number,
                default() { return -1 },
            }
        },

        data() {
            return {
                admins: [],
                participants: [],
                form: new Form({
                    description: this.call.id ? this.call.description : '',
                    actions: this.call.id ? this.call.actions : '',
                    participants: this.call.id ? this.call.participants.map(obj => obj.id) : [],
                    office_user_id: this.call.id ? this.call.office_user_id : this.authUser,
                    subject: this.call.id ? this.call.subject : '',
                }),
            }
        },
        
        computed: {
            title() {
                if (this.call.id) {
                    return 'Edit Support Call Log';
                }

                return 'Create New Support Call Log';
            },

            url() {
                if (this.call.id) {
                    return `/business/support-calls/${this.call.id}`;
                }

                return '/business/support-calls';
            }
        },

        methods: {
            submit() {
                this.form.submit(this.call.id ? 'patch' : 'post', this.url)
                    .then( ({ data }) => {

                    })
            },

            fetchAdmins() {

                axios.get( `/${this.controller}/specialists` )
                    .then( ({ data }) => {
                        this.admins = data;
                    })
                    .catch(e => {
                        this.admins = [];
                    })
            },

            participantExists(user_id) {
                return this.participants.findIndex(obj => obj.id == user_id) >= 0;
            },

            addUser( user ) {

                if (this.participantExists(user.id)){
                    return;
                }

                this.participants.push(user);
                this.form.participants.push(user.id);
            },

            removeParticipant(user_id) {
                this.participants = this.participants.filter(obj => obj.id != user_id);
                this.form.participants = this.participants.map(obj => obj.id);
            }
        },

        mounted() {
            this.fetchAdmins();
            if( this.call.participants ) this.call.participants.forEach( user => this.addUser( user ) );
        },

        watch: {
            call(newVal, oldVal) {
                this.participants = newVal.participants;
            },
        },
    }
</script>

<style>

</style>